import React, { useState, useRef, useImperativeHandle } from 'react';
import SummaryDialog from '@/components/summary-dialog';
import ActivityDetail, { useActivityInfo } from '@/components/activity-detail2';
import Loadable from '@/components/loadable';

import './index.less';

export default React.forwardRef(function SlideInActivityDetail(props, ref) {
  const dialogRef = useRef(null);
  const [activityId, setActivityId] = useState(1);

  const [data, status] = useActivityInfo(activityId);

  useImperativeHandle(ref, () => {
    return {
      show: (id) => {
        dialogRef.current.show();
        setActivityId(id);
      },
      hide: () => {
        dialogRef.current.hide();
      },
    };
  });

  return (
    <SummaryDialog ref={dialogRef}>
      <Loadable LoadingTpl={() => null} loadStatus={status}>
        <div className="slide-in-activity-detail">
          <ActivityDetail data={data} />
          <div className="slide-in-activity-detail-footer">
            <span
              onClick={() => dialogRef && dialogRef.current && dialogRef.current.hide()}
              className="jdbtn jdbtn-primary"
            >
              关闭
            </span>
          </div>
        </div>
      </Loadable>
    </SummaryDialog>
  );
});
